import { css } from '@emotion/css';
import {
  Accordion as AccordionComponent,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from '@prezzee/components';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from '@prezzee/ribbon-ui/lib/components/Modal';
import Typography from '@prezzee/ribbon-ui/lib/components/Typography';
import colors from '@prezzee/ribbon-ui/lib/theme/foundations/colors';
import useDisclosure from '@prezzee/ribbon-ui/lib/hooks/useDisclosure';
import RetailerListModal from '../RetailerListModal';
import { Fragment } from 'react';
import { useProduct } from 'contexts/ProductPageContext';
import ReactMarkdown from 'react-markdown';
import Box from '@prezzee/ribbon-ui/lib/components/Box';

const style = {
  title: css`
    font-weight: 600;
  `,
  accordionPanel: css`
    white-space: pre-wrap;
    font-weight: 300;
    padding-bottom: 20px;

    a {
      color: ${colors.blue[500]};
      text-decoration: underline;

      &:hover {
        color: ${colors.blue[600]};
      }
    }
  `,
  tncModal: css`
    white-space: pre-wrap;

    a {
      color: ${colors.blue[500]};
      text-decoration: underline;

      &:hover {
        color: ${colors.blue[600]};
      }
    }
  `,
};

const ZagCardDetails = () => {
  const participatingBrandsModal = useDisclosure();
  const retailerTncModal = useDisclosure();
  const { sku } = useProduct();

  return (
    <Fragment>
      <AccordionComponent allowZeroExpanded variant="secondary">
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton>Read the full details</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className={style.accordionPanel}>
            <Typography variant="body1" as="h4" color="gray.800" mb="2">
              {sku.name} eGift Card
            </Typography>
            <ReactMarkdown>{sku.description}</ReactMarkdown>
          </AccordionItemPanel>
        </AccordionItem>
      </AccordionComponent>

      {participatingBrandsModal.isOpen && (
        <RetailerListModal
          title="Available brands"
          onClose={participatingBrandsModal.onClose}
          uid={sku.uid}
          showDefaultStore
        />
      )}

      {retailerTncModal.isOpen && (
        <Modal isOpen onClose={retailerTncModal.onClose} isCentered scrollBehavior="inside">
          <ModalOverlay />
          <ModalContent
            width="100%"
            maxW="600"
            maxH="400"
            aria-labelledby="retailer-tnc-dialog-title"
            aria-describedby="retailer-tnc-dialog-description"
            margin="20px"
          >
            <ModalHeader>{sku.name} eGift Card Terms & Conditions</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb="6">
              <Box className={style.tncModal}>
                <ReactMarkdown>{sku.merchant.terms}</ReactMarkdown>
              </Box>
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </Fragment>
  );
};

export default ZagCardDetails;
